import withStyles from '@material-ui/core/styles/withStyles';
import { AlignTargetContainer } from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers';

const styles = (theme) => ({
  root: {
    margin: 'auto',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      margin: 'auto',
      height: '100%',
    },
  },
});
export const CreatorAlignTarget = withStyles(styles, { name: 'CreatorAlignTarget' })(AlignTargetContainer);
